import { database } from "@/lib/firebase-util";
import { collection, doc, DocumentReference, getDoc } from "firebase/firestore";
import { ShoppingCart } from "./GetShoppingCartFromServer";

export type ShoppingCartClient = {
    docRef: DocumentReference,
    data: ShoppingCart
}

const getShoppingCart = async (userID: string): Promise<ShoppingCartClient> => {
    const shoppingCartRef = collection(database, 'shoppingCart');
    const shoppingCartDoc = doc(shoppingCartRef, userID);
    const docSnap = await getDoc(shoppingCartDoc);

    const defaultCart: ShoppingCart = {
        items: [],
        updatedAt: new Date()
    };

    return {
        docRef: shoppingCartDoc,
        data: docSnap.exists() ? (docSnap.data() as ShoppingCart) : defaultCart
    }
}

export default getShoppingCart;